/**
 * Longest foreword heading the printed page can hold. The PDF draws the heading
 * on one line at 28pt DM Serif Display and never shrinks it: 30 ALL-CAPS
 * characters is ~2150px against ~2280px inside the page border at 300 DPI;
 * past ~31 caps / ~37 mixed-case it runs over the border and off the page.
 */
export const FOREWORD_TITLE_MAX_LENGTH = 30;
